import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function WorkerPrint(body, name) {
    let bList = []

    body.forEach(element => {
        const b = [
            element.id.toString() ,
            element.employed?"YES":"NO",
            element.fixedSalary?"YES":"NO",
            element.title.trim(),
            `${(element.firstName.trim())}`,
            `${element.lastName.trim()}`,
            `${element.nic.trim()}`,
            `${element.address.trim().substring(0,30)}`,
            `${element.department.trim()}`,
            element.hiredDate,
            element.startTime,
            printFormatNumber(element.basicSalary.toString()),

    ]

        bList = [...bList, b]
    })
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: "a4",
    });
    const heading = ['Id', 'Employed', 'Fixed Salary', 'Title', 'First Name', "Last Name", 'NIC', "Address", "Department",'Date Hired', 'Start Time', "Basic Salary"];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Dues Report", 300, 40)
    doc.text(`Date:${ToBritishDate(new Date())}`, 300, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'right'},
   //         footStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 6, cellWidth: "auto"},
 //           showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),

            columnStyles: {
                0: {halign: "left"},
                1: {halign: "center"},
                2: {halign: "center"},
                3: {halign: "left"},
                4: {halign: "left"},
                5: {halign: "left"},
                6: {halign: "left"},
                7: {halign: "left"},
                8: {halign: "left"},
                9: {halign: "left"},
                10: {halign: "left"},
                11: {halign: "right"},

            },
        }
    )
    doc.save(`Worker-${ToBritishDate(new Date())}.pdf`);
}



